module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_achievement05-7f55c49d368e205d19a10a378c124162.jpg";